import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {NzDrawerRef} from 'ng-zorro-antd/drawer';
import {ProjectUtilsService} from '../../services/project-utils.service';
import {Equipment, GetParams, ServiceOrder} from '@app/shared';
import {DrawerEscapeBlockerService, EquipmentService, StServiceService} from '@app/core';
import {finalize, forkJoin, Observable} from 'rxjs';
import {GlobalValuesService} from '../../../../core/services/global-values.service';

@Component({
  selector: 'app-asign-equipment-drawer',
  standalone: false,

  templateUrl: './asign-equipment-drawer.component.html',
  styleUrl: './asign-equipment-drawer.component.less',
})
export class AsignEquipmentDrawerComponent implements OnInit, OnDestroy {
  @Input() serviceOrder: ServiceOrder | undefined;

  equipmentsToAsign: Equipment[] = [];

  selectedEquipments: Set<number> = new Set<number>();

  loading: boolean = true;
  asignLoading: boolean = false;

  constructor(
    private drawerRef: NzDrawerRef<string>,
    public ps: ProjectUtilsService,
    public gs: GlobalValuesService,
    public stServiceService: StServiceService,
    private cdr: ChangeDetectorRef,
    private equipmentService: EquipmentService,
    private drawerEscapeBlocker: DrawerEscapeBlockerService,
  ) {}

  ngOnInit() {
    if (!this.gs.equipments$.value) {
      const params: GetParams = {
        startRow: 0,
        endRow: 100,
        sortDirection: 'asc',
        sortProperty: 'id',
      };
      this.equipmentService.getEquipment(params).subscribe({
        next: (rsp) => {
          this.gs.equipments$.next(rsp?.data?.rows || []);
          this.setEquipmentsToAsign();
        },
      });
    } else {
      this.setEquipmentsToAsign();
    }

    // Registrar handler nativo en fase de captura para interceptar Escape
    this.drawerEscapeBlocker.block();
  }

  close(): void {
    this.drawerRef.close();
  }

  setEquipmentsToAsign(): void {
    const equipmentInService =
      (this.serviceOrder
        ? this.serviceOrder.equipments
        : this.ps.selectedService?.equipments) || [];
    // Se hallan los equipos que no esten asignados ya al Servicio
    const serviceEquipmentIds = new Set(
      equipmentInService.map((equipment) => equipment.id),
    );

    this.equipmentsToAsign = (this.gs.equipments$?.value || []).filter(
      (e) => !serviceEquipmentIds.has(e.id),
    );
    this.loading = false;
    this.cdr.detectChanges();
  }

  selectedEquipmentChange(selectedSet: Set<number>): void {
    this.selectedEquipments = new Set(selectedSet);
  }

  async asignEquipmentsToService(): Promise<void> {
    try {
      this.asignLoading = true;
      const selectedIds = Array.from(this.selectedEquipments);
      const assignedEquipments = this.equipmentsToAsign.filter((e) =>
        selectedIds.includes(e.id),
      );

      const requests = assignedEquipments.map((e) =>
        this.equipmentService.createEquipmentService({
          serviceId: this.ps.selectedService!.id,
          equipmentId: e.id,
        }),
      );

      await forkJoin(requests)
        .pipe(finalize(() => (this.asignLoading = false)))
        .toPromise();

      // Se agrega a la lista de equipos asignados al Servicio los equipos seleccionados
      this.ps.selectedService!.equipments = [
        ...(this.ps.selectedService!.equipments || []),
        ...assignedEquipments,
      ];

      this.close();
    } catch (error) {
      console.error('Error asignando equipos', error);
      this.close();
    }
  }

  asignEquipmentsToServiceOrder() {
    this.asignLoading = true;

    const existingEquipmentsIds =
      this.serviceOrder?.equipments?.map((e) => e.id) || [];
    const equipments = this.equipmentsToAsign.filter((e) =>
      this.selectedEquipments.has(e.id),
    );
    this.stServiceService
      .patchServiceOrder({
        id: this.serviceOrder!.id,
        equipmentIds: [
          ...existingEquipmentsIds,
          ...equipments.map((e) => e.id),
        ],
      })
      .pipe(
        finalize(() => {
          this.asignLoading = false;
          this.close();
        }),
      )
      .subscribe({
        next: () => {
          this.serviceOrder!.equipments = [
            ...(this.serviceOrder!.equipments || []),
            ...equipments,
          ];
          // this.serviceOrder = {...this.serviceOrder!, equipments: newEquipments} ;
        },
        error: (e) => console.error(e),
      });
  }

  ngOnDestroy(): void {
    // Remover listener nativo si fue registrado
    this.drawerEscapeBlocker.block();
  }
}
